import { render } from "./ConfirmandoEmail.vue?vue&type=template&id=6dd6476a"
import script from "./ConfirmandoEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmandoEmail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__